import NotificationBlock from "~/components/notificationBlock/NotificationBlock";

import styles from "./FormBaseErrors.module.scss";

type Props = {
  errors: string[];
};

const FormBaseErrors = ({ errors }: Props) => {
  if (errors.length === 0) return null;

  return (
    <NotificationBlock type="danger" className={styles.errorsBlock}>
      {errors.length === 1 ? (
        errors[0]
      ) : (
        <ul>
          {errors.map((message, i) => (
            <li key={i}>{message}</li>
          ))}
        </ul>
      )}
    </NotificationBlock>
  );
};

export default FormBaseErrors;
